// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pc-0";